import { NgModule } from '@angular/core';
import { provideConfig } from '@spartacus/core';
import {
  KnBrCartBaseTranslationChunksConfig,
  KnBrCartBaseTranslations,
} from 'src/feature-libs/kn-br-cart/base/assets/translations/translation';
import { KnBrCartBaseRootModule } from 'src/feature-libs/kn-br-cart/base/root/cart-base-root.module';
import { ADD_TO_CART_FEATURE, ADD_TO_QUOTE_FEATURE, CART_BASE_FEATURE, MINI_CART_FEATURE } from 'src/feature-libs/kn-br-cart/base/root/feature-name';

@NgModule({
  imports: [KnBrCartBaseRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [CART_BASE_FEATURE]: {
          module: () =>
            import('src/feature-libs/kn-br-cart/base/kn-br-cart-base.module').then((m) => m.KnBrCartBaseModule),
        },
      },
    }),
    provideConfig({
      featureModules: {
        [MINI_CART_FEATURE]: {
          module: () =>
            import('src/feature-libs/kn-br-cart/base/components/kn-br-mini-cart/kn-br-mini-cart.module').then(
              (m) => m.KnBrMiniCartModule
            ),
        },
      },
    }),
    provideConfig({
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () =>
            import('src/feature-libs/kn-br-cart/base/components/kn-br-add-to-cart/kn-br-add-to-cart.module').then(
              (m) => m.KnBrAddToCartModule
            ),
        },
      },
    }),
    provideConfig({
      featureModules: {
        [ADD_TO_QUOTE_FEATURE]: {
          module: () =>
            import('src/feature-libs/kn-br-cart/base/components/kn-br-add-to-quote/kn-br-add-to-quote.module').then(
              (m) => m.KnBrAddToQuoteModule
            ),
        },
      },
    }),
    provideConfig({
      i18n: {
        resources: KnBrCartBaseTranslations,
        chunks: KnBrCartBaseTranslationChunksConfig,
        fallbackLang: 'en',
      },
    }),
  ],
})
export class CartBaseFeatureModule {}
